import { render, staticRenderFns } from "./myFavorites.vue?vue&type=template&id=87adc0fe&scoped=true&"
import script from "./myFavorites.vue?vue&type=script&lang=js&"
export * from "./myFavorites.vue?vue&type=script&lang=js&"
import style0 from "./myFavorites.vue?vue&type=style&index=0&id=87adc0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87adc0fe",
  null
  
)

export default component.exports